import { Tooltip } from "@mui/material";
import _ from "lodash";
import { memo, useEffect } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { isMobile } from "react-device-detect";
import { Controller, useFormContext } from "react-hook-form";
import HTMLInput from "../../_Components/HTMLInput";
import SelectComponent from "../../_Components/ReactSelectComponent";
import SplitNumber from "../../_Components/SplitNumber";
import AddCircleRounded from "@mui/icons-material/AddCircleOutlineRounded";


const ReserveItemGroup = ({
  nameDate,
  group,
  reserveDescriptions,
  reserveDetailGroup,
  reserveDetail,
  openModalAddDescription,
  reserveItems,
  showHelpLabel,
  showHelpModalDescription,
  reserveDetailDate,
  formatTime
}) => {
  const { setValue, register, watch, control } = useFormContext()

  useEffect(() => {
    setValue(`${nameDate}-${group.id}-Des`, _.find(reserveDescriptions, function (obj) {
      return _.toString(obj.value) === reserveDetailGroup?.gDesId;
    }))
    setValue(`${nameDate}-Des`, _.find(reserveDescriptions, function (obj) {
      return _.toString(obj.value) === reserveDetailDate?.dDesId;
    }))
  }, [])
  return (
    <div className="bg-white rounded-3 p-2 my-3" style={{ border: "1px solid #ddd " }}>
      <div className=" pb-2" style={{ borderBottom: "1px solid #ddd " }}>
        <Row className="justify-content-md-right position-relative">
          <Col sx="12" sm="7" className="my-auto">
            <input
              key={reserveDetail.service.toString() + `${nameDate}-${group.id}-ID`}
              name={`${nameDate}-${group.id}-ID`}
              {...register(`${nameDate}-${group.id}-ID`)}
              defaultChecked={reserveDetailGroup?.gID != null ? reserveDetailGroup.gID : false}
              type="checkbox"
              title="نمایش/عدم نمایش"
              style={{ margin: "0 5px" }}
            />

            <input
              key={reserveDetail.service.toString() + `${nameDate}-${group.id}-IA`}
              name={`${nameDate}-${group.id}-IA`}
              {...register(`${nameDate}-${group.id}-IA`)}
              defaultChecked={reserveDetailGroup?.gIA != null ? reserveDetailGroup.gIA : false}
              type="checkbox"
              title="فعال/غیرفعال"
              style={{ margin: "0 5px" }}
            />
            <span className="fw-bold"> {group.title}</span>
          </Col>
          <Col xs="10" sm="5" className="mt-2 mt-md-0 pr-2 d-flex align-items-center">
            <Controller
              name={`${nameDate}-${group.id}-Des`}
              control={control}
              render={(field) => (
                <SelectComponent
                  className="w-100"
                  variant="outlined"
                  size="small"
                  noLabel
                  placeholder="توضیحات گروه"
                  {...field}
                  options={reserveDescriptions.map(item => ({ ...item, label: item.label.length > 40 ? item.label.slice(0, 40) + "…" : item.label }))}
                />
              )}
            />
            <Button
              onClick={() => openModalAddDescription(nameDate, group.id)}
              variant="light h-100 mx-1"
            >
              <AddCircleRounded
                fontSize="large"
                className="big-icon"
              />
            </Button>

          </Col>
          {/* <Col xs="2" sm="auto" className="my-auto px-0"></Col> */}
        </Row>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {reserveItems.map(function (item, index) {
          let reserveDetailItem =
            !_.isNil(reserveDetailGroup) && _.isArray(reserveDetailGroup.i)
              ? _.find(reserveDetailGroup.i, { iId: item.id })
              : "";
          const dayCapacity = watch(
            `${nameDate}-${group.id}-${item.id}-C`,
            reserveDetailItem?.iC ? reserveDetailItem.iC : item.defaultReserveCountPerDay,
          ); //بررسی لحظه ای ظرفیت روزانه
          const fullCapacity = watch(
            `${nameDate}-${group.id}-${item.id}-IFC`,
            reserveDetailItem?.iIFC != null ? reserveDetailItem.iIFC : item.isFullCapacity,
          ); //بررسی لحظه ای ظرفیت تکمیل

          if (!_.isUndefined(item) && !_.isEmpty(item))
            return (
              <Row
                key={index}
                className="align-items-center position-relative"
                style={{ margin: "10px 0 15px 0" }}
              >
                <Col xs="12" sm className="px-0 d-flex align-items-center mb-3 mb-sm-0">
                  <input
                    name={`${nameDate}-${group.id}-${item.id}-ID`}
                    {...register(`${nameDate}-${group.id}-${item.id}-ID`)}
                    defaultChecked={reserveDetailItem?.iID != null ? reserveDetailItem.iID : false}
                    type="checkbox"
                    // checked={value || item.iID}
                    title="نمایش/عدم نمایش"
                    style={{ margin: "0 5px" }}
                  />{" "}
                  {showHelpLabel && (
                    <div
                      className="  help-div"
                      style={{ top: "-27px", right: "-3px" }}
                      onClick={() =>
                        showHelpModalDescription(
                          "در صورت غیرفعال بودن نمایش آیتم رزرو در سایت تفریحان، آیتم مورد نظر نمایش داده نمی شود.",
                        )
                      }
                    >
                      <div
                        className="bg-purple-1 rounded-1 text-white px-1 fs-small"
                        style={{ marginRight: "-35px" }}
                      >
                        نمایش / عدم نمایش
                                      </div>
                      <div className="help-div-line bg-purple-1" style={{ height: "20px" }}></div>
                    </div>
                  )}
                  <input
                    name={`${nameDate}-${group.id}-${item.id}-IA`}
                    {...register(`${nameDate}-${group.id}-${item.id}-IA`)}
                    defaultChecked={reserveDetailItem?.iIA != null ? reserveDetailItem.iIA : false}
                    type="checkbox"
                    title="فعال/غیرفعال"
                    style={{ margin: "0 5px" }}
                  />
                  {showHelpLabel && (
                    <div
                      className="  help-div"
                      style={{ right: "22px", top: "-19px" }}
                      onClick={() =>
                        showHelpModalDescription(
                          "در صورت غیرفعال بودن آیتم رزرو، آیتم مورد نظر در سایت تفریحان نمایش داده می شود ولی غیرفعال و غیرقابل انتخاب و به صورت کمرنگ می باشد.",
                        )
                      }
                    >
                      <div
                        className="bg-blue-1 rounded-1 text-white px-1 fs-small"
                        style={{ marginRight: "35px" }}
                      >
                        فعال/غیرفعال{" "}
                      </div>
                      <div className="help-div-line-hr  bg-blue-1"></div>
                      <div className="help-div-line bg-blue-1"></div>
                    </div>
                  )}
                  <span>{item.title}</span>
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  {showHelpLabel && (
                    <div
                      className="bg-light-red-1 rounded-1 text-white px-1 help-div"
                      style={{ top: "-8px", right: "12px" }}
                      onClick={() =>
                        showHelpModalDescription(
                          "حداقل تعداد در سایت تفریحان برای آیتم مورد نظر اعمال می گردد. به این صورت که اگر عددی  به عنوان حداقل در نظر گرفته شود، در سایت تفریحان به عنوان حداقل تعداد رزرو در نظر گرفته می شود . به طور مثال اگر حداقل تعداد رزرو عدد 5 باشد، کمتر از 5 بلیط قابل رزرو نمی باشد.",
                        )
                      }
                    >
                      حداقل
                    </div>
                  )}
                  <HTMLInput
                    hiddenClear={true}
                    registeredParams={{ ...register(`${nameDate}-${group.id}-${item.id}-MinC`) }}
                    onInput={(e) => {
                      // فقط اعداد مثبت و صفر مجاز باشه
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    defaultValue={
                      reserveDetailItem?.iMinC
                        ? reserveDetailItem.iMinC
                        : item.minimumReserveCountPerDay
                    }
                    margin="normal"
                    variant="outlined"
                    size="small"
                    className="form-control text-center englishInput"
                    title="حداقل تعداد"
                    style={{
                      margin: "0 auto",
                      width: "60px",
                      height: "2.8rem",
                      padding: "0",
                    }}
                    type="number"
                    inputMode="numeric"
                  />

                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  {showHelpLabel && (
                    <div
                      className="bg-light-green-1 rounded-1 text-white px-1 help-div"
                      style={{ top: "-8px", right: "12px" }}
                      onClick={() =>
                        showHelpModalDescription(
                          "عدد حداکثر در سایت تفریحان که برای آیتم موردنظر تنظیم می شود، در زمان خرید بلیط استفاده می گردد که بیشتر از این عدد قابل رزرو نمی باشد. به طور مثال اگر عدد 10  به عنوان حداکثر تعداد تعیین شده باشد، فقط 10 بلیط قابل رزرو می باشد.",
                        )
                      }
                    >
                      حداکثر
                    </div>
                  )}
                  <HTMLInput
                    hiddenClear={true}
                    registeredParams={{ ...register(`${nameDate}-${group.id}-${item.id}-C`) }}
                    onInput={(e) => {
                      // فقط اعداد مثبت و صفر مجاز باشه
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    }}
                    defaultValue={
                      reserveDetailItem?.iC ? reserveDetailItem.iC : item.defaultReserveCountPerDay
                    }
                    margin="normal"
                    variant="outlined"
                    size="small"
                    className="form-control text-center englishInput"
                    title="ظرفیت روزانه"
                    style={{
                      margin: "0 auto",
                      width: "60px",
                      height: "2.8rem",
                      padding: "0",
                    }}
                    type="number"
                    inputMode="numeric"
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  {showHelpLabel && (
                    <div
                      className="  help-div"
                      style={{ right: "-3px", top: "-26px", width: "max-content" }}
                      onClick={() =>
                        showHelpModalDescription(
                          "در صورت فعال بودن این گزینه محدودیت روزانه برای این آیتم فعال می شود",
                        )
                      }
                    >
                      <div
                        className="bg-light-orange-2 rounded-1 text-white px-1 fs-small"
                        style={{ marginRight: "-24px", marginTop: "-21px" }}
                      >
                        محدودیت روزانه
                                      </div>

                      <div className="help-div-line-big light-orange-1"></div>
                    </div>
                  )}
                  <input
                    name={`${nameDate}-${group.id}-${item.id}-IDL`}
                    {...register(`${nameDate}-${group.id}-${item.id}-IDL`)}
                    type="checkbox"
                    title="محدودیت روزانه اعمال شود؟"
                    style={{ margin: "0 5px" }}
                    defaultChecked={
                      reserveDetailItem && reserveDetailItem.iIDL != null
                        ? reserveDetailItem.iIDL
                        : false
                    }
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 position-relative">
                  {showHelpLabel && (
                    <div
                      className="  help-div"
                      style={{ right: "-3px", top: "-26px", width: "max-content" }}
                      onClick={() =>
                        showHelpModalDescription(
                          "ظرفیت تکمیل در صورتی که فعال باشد، در سایت تفریحان برای آیتم موردنظر، عنوان نمایشی « ظرفیت تکمیل » نمایش داد می شود که آیتم موردنظر غیرقابل خرید می باشد.",
                        )
                      }
                    >
                      <div
                        className="bg-light-orange-1 rounded-1 text-white px-1 fs-small"
                        style={{ marginRight: "21px" }}
                      >
                        ظرفیت تکمیل{" "}
                      </div>
                      <div className="help-div-line-hr light-orange-1"></div>
                      <div className="help-div-line light-orange-1"></div>
                    </div>
                  )}
                  <input
                    name={`${nameDate}-${group.id}-${item.id}-IFC`}
                    {...register(`${nameDate}-${group.id}-${item.id}-IFC`)}
                    defaultChecked={
                      reserveDetailItem?.iIFC != null ? reserveDetailItem.iIFC : item.isFullCapacity
                    }
                    type="checkbox"
                    title="ظرفیت تکمیل"
                    style={{ margin: "0 5px" }}
                  />
                </Col>
                <Col xs="auto" className="px-0 mb-2 mb-sm-0 min-width-price">
                  <label style={{ margin: "0 5px" }} className="text-decoration-line-through ">
                    <SplitNumber number={item.originalPrice} />
                  </label>
                  <label style={{ margin: "0 5px" }} className="">
                    <SplitNumber number={item.price} />
                  </label>
                </Col>
                <Col xs="auto" sm="auto" className="px-0 mb-2 mb-sm-0">
                  {showHelpLabel && (
                    <div
                      className="help-div"
                      onClick={() =>
                        showHelpModalDescription(
                          "ساعت اتمام فروش زمانی است که در سایت تفریحان بعد از آن ساعت آیتم موردنظر قابل رزرو نمی باشد و عنوان نمایشی « اتمام ساعت فروش » به کاربر نمایش داده می شود.",
                        )
                      }
                    >
                      <div
                        className="help-div-line  bg-normal-danger-1"
                        style={{
                          marginTop: isMobile ? "-36px" : "-13px",
                          height: isMobile && "32px",
                        }}
                      ></div>

                      <div
                        className="bg-normal-danger-1 rounded-1 text-white px-1 help-div"
                        style={{
                          top: isMobile ? "-45px" : "-27px",
                          right: "-46px",
                          width: "max-content",
                        }}
                      >
                        ساعت اتمام فروش
                                      </div>
                    </div>
                  )}
                  <label style={{ margin: "0 5px" }} className="text-primary">
                    {formatTime(item.reservationExpirationTime)}
                  </label>
                </Col>
                <Col xs="auto" sm="auto" className="px-0 text-center mb-2 mb-sm-0">
                  {!_.isEmpty(item.reservationByPhone) && showHelpLabel && (
                    <div
                      className="bg-light-green-blue-1 rounded-1 text-white px-1 help-div"
                      onClick={() =>
                        showHelpModalDescription(
                          "در صورتی که آیکن تلفن در این قسمت نمایش داده شود، آیتم موردنظر در سایت تفریحان قابل رزرو به صورت آنلاین نیست و عنوان نمایشی « رزرو تلفنی » نمایش داده می شود.",
                        )
                      }
                      style={{ top: "-26px", right: "-2px", width: "max-content" }}
                    >
                      رزرو تلفنی
                    </div>
                  )}
                  {((_.isEmpty(item.reservationByPhone) &&
                    (_.isEmpty(_.trim(dayCapacity)) || _.parseInt(dayCapacity) == 0) &&
                    dayCapacity !== undefined) ||
                    fullCapacity) &&
                    showHelpLabel && (
                      <>
                        <div
                          className="bg-dark-pink-1 rounded-1 text-white px-1 help-div"
                          onClick={() =>
                            showHelpModalDescription(
                              "در صورتی که آیکن چشم در این قسمت نمایش داده شود، آیتم موردنظر در سایت تفریحان قابل رزرو نمی باشد . زیرا حداکثر تعداد بلیط برای آن درج نشده است. و برای کاربر تعداد 0 نمایش داده می شود.",
                            )
                          }
                          style={{ top: "-26px", right: "-2px", width: "max-content" }}
                        >
                          غیرقابل رزرو
                                        </div>
                        <div
                          className="help-div-line  bg-dark-pink-1"
                          style={{
                            marginTop: isMobile ? "-36px" : "-13px",
                            height: isMobile && "32px",
                          }}
                        ></div>
                      </>
                    )}
                  <span style={{ width: "32px", display: "inline-block" }}>
                    {!_.isEmpty(item.reservationByPhone) && (
                      <Tooltip title={item.reservationByPhone} arrow placement="top">
                        <i className="fa fa-phone text-primary"></i>
                      </Tooltip>
                    )}

                    {((_.isEmpty(item.reservationByPhone) &&
                      (_.isEmpty(_.trim(dayCapacity)) || _.parseInt(dayCapacity) == 0) &&
                      dayCapacity !== undefined) ||
                      fullCapacity) && (
                        <Tooltip title="آیتم قابل رزرو نمی باشد" arrow placement="top">
                          <i className="fa fa-eye-slash text-danger fs-normal flipX"></i>
                        </Tooltip>
                      )}
                  </span>
                </Col>
              </Row>
            );
        })}
      </div>
    </div>
  )
}

export default memo(ReserveItemGroup)